import { fetchAuthDetails } from './actions/auth-action.helpers.js';

const getAuthToken = async ()=>{
    const authDetails = await fetchAuthDetails();
    if (authDetails.isLoggedIn) {
        return `Bearer ${authDetails.idToken}`;
    }
};
/**
 * return both accessToken and idToken
 * returns { accessToken: string, idToken: string }
 * @returns { accessToken: string, idToken: string }
 */ const getAuthTokens = async ()=>{
    const authDetails = await fetchAuthDetails();
    if (authDetails.isLoggedIn) {
        return {
            accessToken: authDetails.accessToken,
            idToken: authDetails.idToken
        };
    }
};
/**
 * getIsLoggedInAsync
 *
 * We need this function to get the fresh logged in state from cognito APIs itself.
 * This will make sure that we are not using the stale auth state from the store and session is always refreshed.
 * Use this as a priority over useAuth hook.
 *
 * @returns {boolean} isLoggedIn
 */ const getIsLoggedInAsync = async ()=>{
    try {
        const authDetails = await fetchAuthDetails();
        return authDetails.isLoggedIn;
    } catch (error) {
        return false;
    }
};

export { getAuthToken, getAuthTokens, getIsLoggedInAsync };
//# sourceMappingURL=auth.helpers.js.map
